import React from 'react'

function PaymentStepsForOtm() {
  return (
    <div id="stepper">
      <ul class="steps">
        <li class="complete">
          <span>Amount Blocked</span>
        </li>
        <li class="complete">
          <span>Autopay mode</span>
        </li>
      <li class="">
        <span>Setup Autopay</span>
      </li>
    </ul>
  </div>
  )
}

export default PaymentStepsForOtm
